module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-3.bdddb1e1.jpg";